import { z } from 'my-zod'
import { OutfitterSchemas } from '..'

export const CancellationPolicyView = OutfitterSchemas.operatorSystemView.pick({
  cancellationPolicy: true
})

export const CancellationPolicySchemas = CancellationPolicyView.augment({
  cancellationPolicy: z.string().min(1, 'Description is required')
})

export type CancellationPolicySchemasView = z.infer<typeof CancellationPolicyView>
